export default "__VITE_ASSET__092403e5__"